import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL: any = process.env.NODE_ENV === 'production' ? 'https://api.wescout.me' : 'https://api.wescout.me';

export const socket = io(URL, {
  autoConnect: false
});